import React from "react";
import { Box } from "@mui/material";

export function BorderedStepIcon(props: any) {
    const { active, completed, icon, className } = props;
    const isOn = active || completed;
    return (
      <Box
        className={className}
        sx={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          display: "grid",
          placeItems: "center",
          fontSize: 14,
          fontWeight: 700,
          ...(isOn
            ? { backgroundColor: "#FF7292", color: "white", border: "none" }
            : {
                backgroundColor: "transparent",
                color: "#FF7292",
                border: "2px solid #FF7292",
              }),
        }}
      >
        {icon}
      </Box>
    );
  }